import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/internal/Observable';
import { filter, flatMap, map, take } from 'rxjs/operators';
import {
  loadLocalization,
  LoadLocalization,
  loadLocalizationSuccess,
  LoadLocalizationSuccess,
  LocalizationActionsEnum,
  SetLocale,
  setLocaleSuccess,
  SetLocaleSuccess,
} from '../actions';
import { LocalizationService } from '../localization.service';
import { ILocalizationData } from '../localization.data';

@Injectable()
export class LocalizationEffects {
  constructor(
    private _actions: Actions,
    private _localizationService: LocalizationService
  ) {}

  @Effect()
  initLocalization(): Observable<LoadLocalization> {
    return this._actions.pipe(
      ofType(LocalizationActionsEnum.INIT_LOCALIZATION),
      take(1),
      flatMap(() => this._localizationService.isLocalizationsReady()), // wait till localization is ready
      filter((x) => !!x),
      map(() => {
        const localizationData: ILocalizationData = this._localizationService.getLocalizationData();
        return loadLocalization(localizationData);
      })
    );
  }

  @Effect()
  loadLocalization(): Observable<LoadLocalizationSuccess> {
    return this._actions.pipe(
      ofType(LocalizationActionsEnum.LOAD_LOCALIZATION),
      map(({ payload }: LoadLocalization) => loadLocalizationSuccess(payload))
    );
  }

  @Effect()
  setLocale(): Observable<SetLocaleSuccess> {
    return this._actions.pipe(
      ofType(LocalizationActionsEnum.SET_LOCALE),
      map(({ payload }: SetLocale) => {
        this._localizationService.setLocale(payload.locale);
        return setLocaleSuccess(this._localizationService.getCurrentLocale());
      })
    );
  }
}
